import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-confirm-block-card',
  templateUrl: './confirm-block-card.component.html',
  styleUrls: ['./confirm-block-card.component.css']
})
export class ConfirmBlockCardComponent implements OnInit {

  block: boolean;
  errorPassword: boolean = false;
  loader: boolean = false;

  currUser: any;
  password: string|any;

  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<ConfirmBlockCardComponent>,
    public cssService : CssService,
    private authApi: AuthService
  ) {
    this.block = data.block;
  }

  ngOnInit() {
    this.authApi.getUser.subscribe(user => {
      this.currUser = user;
    });
  }

  closeDial(confirm: boolean) {

    this.errorPassword = false;

    if (confirm && this.currUser.providerId === "password") {

      this.loader = true;

      this.authApi.checkPassword(this.password).then((data) => {

        (data) ? this.dialogRef.close(confirm) : this.errorPassword = true;

        this.loader = false;

      });

    } else {

      this.dialogRef.close(confirm);

    }

  }

}
